import { Box, Typography } from '@mui/material';
import { PieceHeading } from './PieceHeading';
import {
  HERO_PANEL_BG,
  HERO_PANEL_BORDER,
  HERO_TEXT_SECONDARY,
  HERO_WORKLOAD_OK,
  HERO_WORKLOAD_WARN,
  HERO_WORKLOAD_LOW,
  HERO_FONT_MONO,
} from '../designTokens';

type WorkloadTone = 'ok' | 'warn' | 'low';

const PEOPLE: { name: string; pct: number; tone: WorkloadTone }[] = [
  { name: 'Alex Chen',    pct: 92,  tone: 'ok'   },
  { name: 'Priya Patel',  pct: 78,  tone: 'ok'   },
  { name: 'Jordan Kim',   pct: 108, tone: 'warn'  },
  { name: 'Sam Williams', pct: 64,  tone: 'low'   },
  { name: 'Lina Ortiz',   pct: 85,  tone: 'ok'   },
];

const TONE_COLOR: Record<WorkloadTone, string> = {
  ok:   HERO_WORKLOAD_OK,
  warn: HERO_WORKLOAD_WARN,
  low:  HERO_WORKLOAD_LOW,
};

export function PieceWorkload() {
  return (
    <Box sx={{ maxWidth: 520, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <PieceHeading eyebrow="Workload at a glance" line1="Balance the load." line2="Catch the over-allocations." />
      <Box
        sx={{
          background: HERO_PANEL_BG,
          border: `1px solid ${HERO_PANEL_BORDER}`,
          borderRadius: '12px',
          p: '14px 16px',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {PEOPLE.map((p) => (
            <Box
              key={p.name}
              sx={{
                display: 'grid',
                gridTemplateColumns: '100px 1fr 44px',
                alignItems: 'center',
                gap: 1.5,
                fontSize: '0.71875rem',
                color: HERO_TEXT_SECONDARY,
              }}
            >
              <Typography
                component="span"
                sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: 'inherit', color: 'inherit' }}
              >
                {p.name}
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  height: 8,
                  borderRadius: '4px',
                  background: 'rgba(255,255,255,0.06)',
                  overflow: 'hidden',
                }}
              >
                <Box
                  aria-hidden
                  sx={{
                    position: 'absolute',
                    left: 'calc(100% / 1.1)',
                    top: -2,
                    bottom: -2,
                    width: '1px',
                    background: 'rgba(255,255,255,0.18)',
                  }}
                />
                <Box
                  sx={{
                    width: `${Math.min(p.pct, 110) / 1.1}%`,
                    height: '100%',
                    background: TONE_COLOR[p.tone],
                    borderRadius: '4px',
                  }}
                />
              </Box>
              <Typography
                component="span"
                sx={{
                  fontFamily: HERO_FONT_MONO,
                  fontVariantNumeric: 'tabular-nums',
                  textAlign: 'right',
                  fontSize: 'inherit',
                  color: p.tone === 'warn' ? HERO_WORKLOAD_WARN : 'inherit',
                }}
              >
                {p.pct}%
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
